import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from 'src/app/services/auth-service/auth.service';
import { MessageService } from 'src/app/services/message/message.service';

@Component({
  selector: 'app-homes',
  templateUrl: './homes.component.html',
  styleUrls: ['./homes.component.scss']
})
export class HomesComponent implements OnInit {

  loading = true;
  wlc: any;
  name = "";
  showProfilePopup = false;
  profile: string;
  commonRef: string;
  total_projects = 0;
  project_step = 0;
  stat_projects = 0;
  stat_documents = 0;
  stat_exchanges = 0;
  stat_tasks = 0;
  showStatutMenu = false;

  activeSubMenu: string | null = null;

  selectedStatus: string = null;

  constructor(private authService: AuthService, private messageService: MessageService, private route: ActivatedRoute) { }

  ngOnInit() {
    this.total_projects = this.messageService.getListProject().length;
    const currentUser = JSON.parse(localStorage.getItem('currentUser'));
    this.name = currentUser.givenName;
    if (!currentUser.familyName || currentUser.familyName.trim() === '') {
      this.showProfilePopup = true;
    }
    this.route.paramMap.subscribe(params => {
      this.wlc = params.get('wlc');
    });
    this.authService.endLoading.subscribe((term) =>{ 
      if(term === "1"){
        this.loading = false;
        this.total_projects = this.messageService.getTotalProject();
      }
    });
    this.authService.changeStepProject.subscribe((term) =>{ 
      if(term){
        this.project_step = Number(term);
      }
    });
    if(this.messageService.getListProject().length > 0) {
      
      this.loading = false;
    }
    this.getStats();
  }

  toggleStatutMenu(): void {
    this.showStatutMenu = !this.showStatutMenu;
    if (!this.showStatutMenu) {
      this.activeSubMenu = null;
    }
  }

  openSubMenu(type: string, event: Event): void {
    event.stopPropagation();
    this.activeSubMenu = this.activeSubMenu === type ? null : type;
  }

  chooseStatus(value: string): void {
    this.selectedStatus = value;
    this.showStatutMenu = false;
    this.activeSubMenu = null;
    // ici tu peux émettre un event vers le parent, appeler un service, etc.
    console.log('Statut choisi :', value);
  }

  // ferme le menu si on clique en dehors
  closeAll(): void {
    console.log("cliqued")
    this.showStatutMenu = false;
    this.activeSubMenu = null;
  }

  getStats(){
    this.authService.getGlobalStats().subscribe(  
    (success) => {
     
      var dataArray = success['hydra:member'];
      this.stat_projects = dataArray.totalProject;
      this.stat_documents = dataArray.totalFile;
      this.stat_exchanges = dataArray.totalMessage;
      this.stat_tasks = dataArray.totalTask;
    },
    (error) => {
      alert('Erreur global stats ! : ' + error)
    });
   }

}
